import { StylesProvider, jssPreset } from '@material-ui/core/styles'
import { create } from 'jss'
import rtl from 'jss-rtl'

// Configure JSS
const jss = create({ plugins: [...jssPreset().plugins, rtl()] })

function RTL({ children }: { children: JSX.Element }) {
  return (
    <div dir="rtl">
      <StylesProvider jss={jss}>{children}</StylesProvider>
    </div>
  )
}
export default RTL
